import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Translations
import translate from '../Translate.js';

// Dependencies
import DOMPurify from 'dompurify';

const RegisterIntro = observer(class RegisterIntro extends React.Component {
  render() {
    const { translation } = this.props;

    return(
      <main className="page wrap">
        <div className="panel--brief">
          <h1 className="panel__title">{translation.heading}</h1>

          <div className="panel__copy" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.body)}}></div>

          <Link className="btn" to="/register/step-01">{translation.button}</Link>
        </div>
      </main>
    )
  }
})

export default translate('RegisterIntro')(RegisterIntro);


// WEBPACK FOOTER //
// ./src/app/components/Register/Intro.js